import React, { useState, useEffect, useMemo, useRef } from "react";
import { 
    Grid, 
    Card,
    CircularProgress
} from "@material-ui/core";
import axios from "axios";
import Sockets from '../../Sockets';

const Logs = () => {

    const [loading, setLoading] = useState(false);
    const [hasManuallyScrolled, setHasManuallyScrolled] = useState(false);
    const [watchForScrollEvents, setWatchForScrollEvents] = useState(false);
    const [data, setData] = useState(undefined);
    const logEnd = useRef(undefined);

    const fetchData = async () => {
        setLoading(true);
        const result = await axios.get('logs');
        if (result.data) {
            let d = result.data;
            if (d) {
                d = d.replace(/\n/g, '\n\n\n');
                setData(d);
            } else {
                setData(undefined);
            }
        } else {
            setData(undefined);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
        
        Sockets.shared().echo.channel('logs').listen('ConsoleLog', (e) => {
            console.log(`reiceved new message from socket`, e);
            fetchData();
        });
    }, []);

    useEffect(() => {
        if (!hasManuallyScrolled) {
            setWatchForScrollEvents(false);
            setTimeout(() => {
                if (logEnd) {
                    logEnd.current.scrollIntoView({ behavior: "smooth" });
                    setTimeout(() => {
                        setWatchForScrollEvents(true);
                    }, 2000);
                }
            }, 200);
        } 
    }, [data]);

    const text = useMemo(() => {
        if (data) {
            return data.replace(/\n\n/g, '\n').replace(/\n/g, '<br>');
        }

        return '';
    }, [data]);
    
    return (
        <Grid conatiner>
            <Grid item xs={12}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card 
                            style={{ 
                                backgroundImage: 'linear-gradient(rgba(30, 30, 30, 1), black)', 
                                padding: 25,
                                height: 450,
                                overflowY: 'scroll',
                                overflowX: 'hidden'
                            }}
                            onScroll={() => {
                                if (watchForScrollEvents) {
                                    setHasManuallyScrolled(true);
                                }
                            }}
                        >
                            <p style={{ color: 'white' }}>
                                <div dangerouslySetInnerHTML={{ __html: text }} />
                            </p>
                            <div style={{ float:"left", clear: "both" }} ref={(el) => { logEnd.current = el; }} />
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify="flex-end">
                            <Grid item>
                                {loading && <CircularProgress color="primary" />}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
export default Logs;